import React, { useState } from "react";
import './FAQ.css';
import faqData from './faqData';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="faq-container">
        <div className="faq-left">
          <div className="faq-icon">
            <HelpOutlineIcon style={{ fontSize: '2.5rem',
                color: 'white',
                backgroundColor: 'green',
                padding: '0.5rem',
                borderRadius: '5px',
                marginRight: '6rem',
                flexShrink: 0 }} />
          </div>
          <h2>Frequently <br/>asked <br/>questions</h2>
        </div>
        <div className="faq-right">
          {faqData.map((item, idx) => (
            <div key={idx} className="faq-item">
              <button
                className={`faq-question ${openIndex === idx ? "active" : ""}`}
                onClick={() => handleToggle(idx)}
              >
                {item.question}
                <span className="arrow">{openIndex === idx ? "▲" : "▼"}</span>
              </button>
              {openIndex === idx && (
                <div className="faq-answer">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;